import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ModalPageRegistration } from './registrationModal.page';
import { ValidationsModule } from '../../validations-module/validations.module';

const routes: Routes = [
  {
    path: '',
    component: ModalPageRegistration
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    ValidationsModule
  ],
  declarations: [ModalPageRegistration]
})
export class RegistrationPageModule {}
